<script>
export default {
    name: "CrystalIcon",
    props: {
        staticType: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: "#000",
        },
        secondaryColor: {
            type: [String, null],
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasWhiteColor() {
            return (
                this.color == "#fff" ||
                this.color == "#ffffff" ||
                this.secondaryColor == "#fff" ||
                this.secondaryColor == "#ffffff"
            );
        },
    },
};
</script>

<template>
    <div
        class="diamond"
        :class="{ 'diamond--active': isActive, 'diamond--static': staticType }"
        :style="{
            background: `linear-gradient(90deg, ${color} 50%, ${secondaryColor ? secondaryColor : color} 50%)`,
            outline: hasWhiteColor ? '1px solid #c5bbb9' : '',
        }"></div>
</template>

<style scoped lang="less">
.diamond {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    .trs(all);
    &:not(.diamond--static) {
        &:hover {
            transform: scale(1.4);
            box-shadow: 0 0 0 2.5px transparent, 0 0 0 3.5px transparent;
        }
    }
    &--active {
        box-shadow: 0 0 0 2.5px #fff, 0 0 0 3.5px #000;
    }
}
</style>
